import { createReducer, on } from '@ngrx/store';
import {
  loadPermissions,
  loadPermissionsSuccess,
  loadPermissionsFailure,
  clearPermissions,
  setPermissions,
} from '../actions/permission.actions';

export interface Permission {
  code: string;
} 

export interface PermissionState {
  data: Permission[] | null;
  loading: boolean;
  error: string | null;
}

export const initialState: PermissionState = {
  data: [],
  loading: false,
  error: null,
};

export const permissionReducer = createReducer(
  initialState,

  on(loadPermissions, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(loadPermissionsSuccess, (state, { response }) => ({
    ...state,
    data: response,
    loading: false,
    error: null,
  })),

  on(loadPermissionsFailure, (state, { error }) => ({
    ...state,
    data: null,
    loading: false,
    error,
  })),
 
  on(setPermissions, (state, { data }) => ({
    ...state,
    data,
    loading: false,
    error: null,
  })),

  on(clearPermissions, (state) => ({
    ...state,
    data: [],
    loading: false,
    error: null
  }))
)